<style scoped>

.overlay {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 130;
  pointer-events: none;
  flex-direction: column;
}
.subtitle-text {
  color: white;
  background-color: rgba(43, 51, 63, 0.5);
}
.subtitle-wrapper {
  text-align: center;
}

</style>

<template>

<div>
  <div class="overlay full-width full-height display-flex" v-if="index !== -1">
    <div class="flex-item" />
    <div v-for="subtitle in subtitles[index]" class="subtitle-wrapper">
      <span v-if="currentTime >= subtitle.startTime && currentTime <= subtitle.endTime" class="subtitle-text">
        {{subtitle.text}}
      </span>
    </div>
    <div style="height: 40px;" />
  </div>
</div>

</template>

<script>

export default {
  name: 'SubtitleOverlay',
  components: {
  
  },
  props: {
    subtitles: {
      type: Array,
      default() {
        return [];
      }
    },
    mediaId: {
      type: String,
      required: true
    },
    currentTime: {
      type: Number,
      required: true
    },
    index: {
      type: Number,
      default: -1
    },
  },
  data() {
    return {
      
    }
  },
  methods: {
    
  }
}
</script>
